export default "__VITE_ASSET__8fbd0ac7__"